import { Snackbar } from "@mui/material";
import { useState } from "react";
import ReactDOM from "react-dom";

export const useSnackBar = () => {
	const [openAlert, setOpenAlert] = useState(false);
	const [message, setMessage] = useState("");

	const [autoHideDuration, setAutoHideDuration] = useState(2000);

	const handleOpenSnackbar = (text: string, autoHideDuration?: number) => {
		setMessage(text);
		setOpenAlert(true);

		if (autoHideDuration) {
			setAutoHideDuration(autoHideDuration);
		}
	};

	const renderMessageSnackbar = (props?: {
		vertical?: "top" | "bottom";
		horizontal?: "left" | "center" | "right";
		onClick?: () => void;
	}) => {
		const { vertical = "top", horizontal = "center" } = props || {};

		return ReactDOM.createPortal(
			<Snackbar
				anchorOrigin={{ vertical, horizontal }}
				autoHideDuration={autoHideDuration}
				message={message}
				open={openAlert}
				onClick={props?.onClick}
				onClose={() => setOpenAlert(false)}
			/>,
			document.body
		);
	};

	return { handleOpenSnackbar, renderMessageSnackbar };
};
